import { render, staticRenderFns } from "./EffectTypeDelete.vue?vue&type=template&id=fbb6fd02&scoped=true&"
import script from "./EffectTypeDelete.vue?vue&type=script&lang=js&"
export * from "./EffectTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb6fd02",
  null
  
)

export default component.exports